<template>
  <Modal
    :width="568"
    :visible="props.visible"
    @cancel="quit"
    :wrapClassName="$style.Dialog"
    title="AI生成内容下载"
    :mask-closable="false"
    :z-index="zIndex"
  >
    <p :class="$style.Title">作品含AI生成内容,是否保留AI显式标识?</p>
    <img :src="imageSrc" style="width: 100%; height: 180px; object-fit: contain" />
    <Spin :spinning="loading">
      <RadioGroup
        v-model:value="value"
        :class="$style.RadioGroup"
        :options="[
          {
            label: '保留',
            value: true,
          },
          {
            label: '去除',
            value: false,
          },
          // {
          //   label: '每次询问',
          //   value: null,
          // },
        ]"
      ></RadioGroup>
    </Spin>
    <div :class="$style.Content">
      根据《人工智能生成合成内容标识办法》，灵图已对（含）AI
      生成内容添加显式标识及隐式标识，其中显式标识可以申请去除。后续您通过互联网传播由灵图生成的 AI
      内容时，应保持上述内容标识的准确性、完整性。网络传播平台在获知或检测到您上传内容为 AI
      生成内容时会在您发布的内容周围添加显著提示，详情可查阅《用户协议》
    </div>
    <span>
      <Checkbox :checked="hasRead" @update:checked="handleChecked">我已阅读并同意</Checkbox>
      <a @click="handleOpenPDFModal">《用户协议》</a>
    </span>

    <template #footer>
      <span>
        <Checkbox v-model:checked="remember">记住选项，可在</Checkbox>
        <a @click.stop="goAccount">&nbsp;账号管理</a>
        修改
      </span>
      <div>
        <!-- <Button @click="handleOk(true)">保留</Button> -->
        <!-- <Button type="primary" @click="handleOk(false)">去除</Button> -->
        <Button type="primary" @click="handleUpdateWatermark(value)">确认</Button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
  import { openPDFModal } from '@lingtu/components';
  import { Button, Checkbox, Modal, message, RadioGroup, Spin } from 'ant-design-vue';
  import to from 'await-to-js';
  import { computed, onMounted, ref } from 'vue';
  import { apis } from '/@/apis';
  import { useUserStore } from '/@/store/modules/user';

  const { user } = apis;
  const userStore = useUserStore();
  const props = defineProps({
    visible: {
      type: Boolean,
      default: false,
    },
  });
  const emits = defineEmits(['ok', 'cancel', 'update:visible']);

  const __key__ = '__AI_WATERMARK_PROTOCOL_REMEMBER__';

  const remember = ref(true);
  const zIndex = ref(9999);

  const imageSrc = computed(() => {
    if (value.value === true)
      return 'https://static.lingvisions.com/public/fb2506bcd43849dabb2faa49c87a01c1.png';

    if (value.value === false)
      return 'https://static.lingvisions.com/public/71724199dc8945e486e54ed7fa06f065.png';

    return 'https://static.lingvisions.com/public/76323e702de544c48775fe6a68ad906f.png';
  });

  const hasRead = ref(localStorage.getItem(__key__) === '1');

  const userSettings = ref();
  const loading = ref(false);
  const value = ref(
    userStore?.userInfo?.watermark === null ? false : userStore?.userInfo?.watermark
  );
  async function getUserSettings() {
    loading.value = true;
    const [err, res] = await to(user.userSettings());
    if (!err) {
      userSettings.value = res;
    }
    loading.value = false;
  }

  async function handleUpdateWatermark(watermark) {
    if (!hasRead.value) {
      zIndex.value = 1000;
      message.warn('请先阅读并同意《用户协议》');
      return;
    }

    if (remember.value) {
      loading.value = true;
      const [err] = await to(apis.user.setWatermark({ watermark }));
      if (!err) {
        userStore.setUserInfo({
          watermark,
        });
      }
      loading.value = false;
    }

    emits('ok', watermark, remember.value);
    emits('update:visible', false);
  }

  function handleChecked(v) {
    hasRead.value = v;
    localStorage.setItem(__key__, v ? '1' : '0');
  }

  function quit() {
    emits('cancel');
    emits('update:visible', false);
  }
  function handleOk(v) {
    if (!hasRead.value) {
      zIndex.value = 1000;
      message.warn('请先阅读并同意《用户协议》');
      return;
    }
    emits('ok', v, remember.value);
    emits('update:visible', false);
  }

  function handleOpenPDFModal() {
    zIndex.value = 1000;
    openPDFModal({
      src: 'https://static.lingvisions.com/public/4d58d4ab4e654e8180e8a3dd20aa2b44.pdf',
      title: '用户协议',
    });
  }

  function goAccount() {
    if (location.pathname.includes('/batch')) {
      window.open('/aiad/batch/account', '_blank');
    } else {
      window.open('/aiad/account', '_blank');
    }
  }

  onMounted(() => {
    getUserSettings();
  });
</script>

<style lang="less" module>
  .Dialog {
    :global {
      font-family: 'PingFang SC';

      .ant-modal-title {
        color: var(--colorText, rgba(255, 255, 255, 0.85));
        font-family: 'PingFang SC';
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 150% */
      }

      .ant-modal-header {
        display: flex;
        padding: 16px 24px 8px 24px;
        align-items: flex-start;
        gap: 16px;
        align-self: stretch;
        border-bottom: none;
      }

      .ant-modal-body {
        background-color: #282828;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 8px;
      }

      .ant-modal-footer {
        display: flex;
        padding: 8px 24px 16px 24px;
        justify-content: space-between;
        align-items: center;
        align-self: stretch;
        border-top: none;
      }

      .ant-checkbox-inner {
        border-radius: 4px;
      }

      .ant-checkbox-wrapper {
        span {
          padding-right: 0;
        }
      }
    }
  }

  .Title {
    color: rgba(255, 255, 255, 0.85);
    /* LG/LG Normal */
    font-family: 'PingFang SC';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }

  .Content {
    color: rgba(255, 255, 255, 0.85);
    font-family: 'PingFang SC';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px; /* 157.143% */
    // margin-bottom: 16px;
  }

  .RadioGroup {
    :global {
      .ant-radio-inner {
        border-color: #424242;
        background-color: #1f1f1f;
      }

      .ant-radio-wrapper {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.85);
      }
    }
  }
</style>
